import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header block" }
const _hoisted_2 = { class: "detail" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "container block" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "contract-year-box" }
const _hoisted_8 = { class: "row year-row" }
const _hoisted_9 = { class: "row year-row" }
const _hoisted_10 = { class: "footbtn" }

import alertBox from '@/components/alert-box.vue'

import axios from 'axios'
import { downLoadFile } from '../utils/util'
import { defineComponent } from 'vue'
import {
    getContractTempletes,
    ContractRecordDto,
    openContract,
    setContractYear
} from '@/api/contract'
import { exportContractRecord } from '@/api/export'
import store from '@/store/index'
import { number } from 'echarts'
const __default__ = defineComponent({
    name: 'ContractTemplate',
    data() {
        return {
            active: '全部',
            total: 0,
            pageSize: 10,
            pageNum: 1,
            tableData: [] as ContractRecordDto[],
            payDateSolt: '',
            searchValue: '',
            searchText: '',
            selects: [] as string[],
            yearSetNum: '' as '' | number,
            setYearId: '' as '' | number,
            radioUnit: 2, // 可被改变的
            unit: 0 // 存储的
        }
    },
    created() {
        this.handleCurrentChange()
    },
    methods: {
        // 编辑年份
        onRadioUnit() {

            // console.log(this.radioUnit, 'radioUnit')
        },
        handleCurrentChange() {
            getContractTempletes({
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                searchText: this.searchValue,
                beginCreateTime: this.payDateSolt ? this.payDateSolt[0] : '',
                endCreateTime: this.payDateSolt ? this.payDateSolt[1] : ''
            }).then(res => {
                this.total = res.total
                this.tableData = res.list
            })
        },
        handleSizeChange() {
            this.pageNum = 1
            this.handleCurrentChange()
        },
        search() {
            this.searchValue = this.searchText
            this.pageNum = 1
            this.handleCurrentChange()
        },
        onReset() {
            this.searchText = ''
            this.payDateSolt = ''
            this.search()
        },
        async onExport() {
            const result = await exportContractRecord({
                ids: this.selects.join(','),
                searchText: this.searchValue
            }, {
                loading: true
            })
            if (!result.fileUrl && result.exportStatus === 0) {
                store.commit('getLongPollingFile', result)
            } else {
                // window.location.href = result.fileUrl
                // this.$message.success('导出成功！')
                axios({
                    url: result.fileUrl,
                    method: 'GET',
                    responseType: 'blob'
                }).then(async (response) => {
                    await downLoadFile(response, result.exportType, result.updateTime, result.remark)
                    await this.$message.success('导出成功！')
                })
            }
            // window.location.href =
            //     process.env.VUE_APP_BASE_URL +
            //         '/common/download?delete=true&fileName=' +
            //         result

            // this.$message.success('导出成功！')
        },
        handleSelectionChange(selects: { id: string }[]) {
            this.selects = selects.map(item => item.id)
        },
        async onOpenContract() {
            const result = await openContract()
            window.open(result.consoleUrl)
        },
        async onYearSubmit() {
            if (this.radioUnit === 0 && this.yearSetNum > 10) {
                this.$message.error('不可高于10年')
                return
            } else if (this.radioUnit === 2 && this.yearSetNum > 3650) {
                this.$message.error('不可高于3650天')
                return
            } else if (this.radioUnit === 1 && this.yearSetNum > 120) {
                this.$message.error('不可高于120个月')
                return
            }
            if (this.setYearId && this.yearSetNum) {
                await setContractYear({
                    unit: this.radioUnit,
                    id: this.setYearId,
                    effectiveTime: this.yearSetNum
                })
                this.setYearId = ''
                this.yearSetNum = ''
                this.handleCurrentChange()
                this.$message.success('修改成功！')
            } else {
                this.$message.error('请输入修改年限')
            }
        }
    }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.payDateSolt,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payDateSolt) = $event)),
            type: "daterange",
            class: "date-solt",
            "unlink-panels": "",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            onChange: _ctx.handleCurrentChange,
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue", "onChange"]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入派遣单位/人员名称",
            class: "input search-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "搜索"),
          _createElementVNode("button", {
            class: "btn-white",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, "重置"),
          _createElementVNode("button", {
            class: "btn-lightblue setbtn flex-center",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onOpenContract && _ctx.onOpenContract(...args)))
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "创建合同模版", -1)),
            _createVNode(_component_el_icon, { class: "custom-plus-icon" }, {
              default: _withCtx(() => [
                _createVNode(_component_CirclePlus)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "selection" }),
            _createVNode(_component_el_table_column, {
              prop: "companyName",
              width: "200",
              label: "被派遣单位名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "templateName",
              width: "160",
              label: "模版名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "flowDescription",
              label: "合同描述"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userName",
              label: "创建人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "effectiveTime",
              label: "合同有效期"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.effectiveTime ? scope.row.effectiveTime + (scope.row.unit === 1 ? '月' : scope.row.unit === 2 ? '日' : '年') : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              width: "200",
              label: "创建时间"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                _createElementVNode("p", {
                  class: "link",
                  onClick: 
                            () => {
                                _ctx.setYearId = scope.row.id
                                _ctx.yearSetNum = scope.row.effectiveTime
                                _ctx.unit = scope.row.unit
                                _ctx.radioUnit = scope.row.unit
                            }
                        
                }, " 编辑模版 ", 8, _hoisted_6)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    (_ctx.setYearId)
      ? (_openBlock(), _createBlock(alertBox, {
          key: 0,
          "data-title": "编辑合同年限",
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setYearId = '')),
          width: "500px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text" }, [
                  _createElementVNode("span", { class: "important" }, "*"),
                  _createTextVNode("年限类型")
                ], -1)),
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.radioUnit,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.radioUnit) = $event)),
                  onChange: _ctx.onRadioUnit,
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("按日")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("按月")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("按年")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text" }, [
                  _createElementVNode("span", { class: "important" }, "*"),
                  _createTextVNode("合同年限")
                ], -1)),
                _createVNode(_component_el_input, {
                  type: "number",
                  style: {"width":"240px"},
                  class: "textarea",
                  modelValue: _ctx.yearSetNum,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.yearSetNum) = $event))
                }, {
                  append: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.radioUnit === 1 ? '月' : _ctx.radioUnit === 2 ? '日' : '年'), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn mini-btn whitebtn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setYearId = ''))
                }, " 取消 "),
                _createElementVNode("button", {
                  class: "btn mini-btn",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onYearSubmit && _ctx.onYearSubmit(...args)))
                }, " 确定修改 ")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})